import { Suspense } from "react";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";

const BillingSettingsComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "BillingSettingsPage" */ "@circle-react/components/SettingsApp/Plan/Billing"
    ),
);

export const BillingSettingsPage = () => (
  <Suspense fallback={<PageLoader />}>
    <BillingSettingsComponent />
  </Suspense>
);
